const PUBLIC_KEY_BASE64 =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCSi1vKY6WB/q+FwkSP1vyQO3u5OQBeO5bhduuYRAfTGY1BXRvujNTGwL8uV0ewUzIYAQmDfjmQIodVmu8sKtrEF0g/IpqiES0OTnusdoKMynNggE0pG/fNAEds2j/ruSLNpkh+zPd+/bUW1p/9D+xazoxsE9xPpI/GbRKhSzdqVQIDAQAB';

const binaryStringToUint8Array = (binaryString) => {
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

const toBase64 = (bytes) => {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
};

let importedPublicKeyPromise = null;

const getPublicKey = async () => {
  if (!importedPublicKeyPromise) {
    const keyBytes = binaryStringToUint8Array(window.atob(PUBLIC_KEY_BASE64));
    importedPublicKeyPromise = window.crypto.subtle.importKey(
      'spki',
      keyBytes.buffer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-1',
      },
      false,
      ['encrypt']
    );
  }

  return importedPublicKeyPromise;
};

export const encryptPassword = async (value) => {
  const publicKey = await getPublicKey();
  const encodedValue = new TextEncoder().encode(value);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    encodedValue
  );

  return toBase64(new Uint8Array(encrypted));
};
